import React from 'react';
import { Box, Stepper, Step, StepLabel, Typography } from '@mui/material';

export interface StepNavigationProps {
  currentStep: number;
  totalSteps: number;
  onStepChange: (step: number) => void;
  stepTitles?: string[];
  showStepTitles?: boolean;
  completedSteps?: number[];
}

export const StepNavigation: React.FC<StepNavigationProps> = ({
  currentStep,
  totalSteps,
  onStepChange,
  stepTitles = [],
  showStepTitles = true,
  completedSteps = [],
}) => {
  const steps = Array.from({ length: totalSteps }, (_, index) => index + 1);
  
  const isStepCompleted = (step: number) => completedSteps.includes(step);
  const canNavigateToStep = (step: number) => {
    // Can navigate to current step, completed steps, or next step if current is completed
    return step === currentStep || isStepCompleted(step) || 
           (step === currentStep + 1 && isStepCompleted(currentStep));
  };

  const getStepTitle = (step: number) => {
    if (stepTitles[step - 1]) {
      return stepTitles[step - 1];
    }
    return `Step ${step}`;
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Stepper activeStep={currentStep - 1} orientation="horizontal">
        {steps.map((step) => (
          <Step key={step} completed={isStepCompleted(step)}>
            <StepLabel
              onClick={() => canNavigateToStep(step) && onStepChange(step)}
              sx={{
                cursor: canNavigateToStep(step) ? 'pointer' : 'default',
                '&:hover': canNavigateToStep(step) ? {
                  opacity: 0.7,
                } : {},
              }}
            >
              {showStepTitles && (
                <Typography variant="body2" component="span" >
                  {getStepTitle(step)}
                </Typography>
              )}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      
    
    </Box>
  );
}; 